import { ColorValue, ImageSourcePropType, StyleSheet } from 'react-native';
import Animated, {
  Extrapolation,
  interpolate,
  SharedValue,
  useAnimatedStyle,
} from 'react-native-reanimated';

interface InfoCarouselHeroImageProps {
  image: ImageSourcePropType;
  imageBackgroundColor?: ColorValue;
  stepPosition: number;
  pageWidth: number;
  scrollOffset: SharedValue<number>;
}

const InfoCarouselHeroImage = ({
  image,
  imageBackgroundColor,
  stepPosition,
  pageWidth,
  scrollOffset,
}: InfoCarouselHeroImageProps) => {
  const imageStyle = useAnimatedStyle(() => ({
    opacity: interpolate(
      scrollOffset.value / pageWidth - stepPosition,
      [-1, 0, 1],
      [0, 1, 0],
      Extrapolation.CLAMP,
    ),
  }));

  return (
    <Animated.Image
      source={image}
      resizeMode="cover"
      accessibilityIgnoresInvertColors
      importantForAccessibility="no-hide-descendants"
      accessibilityElementsHidden
      style={[
        styles.image,
        { backgroundColor: imageBackgroundColor },
        imageStyle,
      ]}
    />
  );
};

const styles = StyleSheet.create({
  image: {
    height: '100%',
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%',
  },
});

export default InfoCarouselHeroImage;
